import React from 'react';
import { translate } from '../Services/translation';
import { useSelector, useDispatch } from 'react-redux';
import { toggle, update } from '../Actions/Cart.action';
import MiniCartProduct from './MiniCart.Product';

const MiniCart = () => {
  const dispatch = useDispatch();
  const {
    quantity,
    orderTotal,
    checkoutUrl,
    showInfo,
    orderRows,
    includeVAT,
    freeShippingAmount,
  } = useSelector((state) => state.cart);
  const onToggle = () => dispatch(toggle());

  return (
    <div className="cart cart--mini">
      <a className="header-link" onClick={() => onToggle()}>
        <div className="cart__icon-wrapper">
          <span className="cart__quantity">{quantity}</span>
          <i className="far fa-shopping-cart"></i>
        </div>
      </a>
      <div className={`cart__info ${!showInfo ? 'cart__info--hidden' : ''}`}>
        <div className="cart__header">
          <div>
            <div className="cart__header-circle"></div>
          </div>
          <div className="cart__header-text">
            {translate('minicart.heading')}
          </div>
        </div>
        <div className="mini-cart-wrap">
          <div className="mini-cart-wrap__scroll">
            {orderRows.map((orderRow) => {
              const { rowSystemId, quantity } = orderRow;
              return (
                <MiniCartProduct
                  key={rowSystemId}
                  product={orderRow}
                  onCartItemIncrement={() =>
                    dispatch(update(orderRow.articleNumber, quantity + 1))
                  }
                  onCartItemDecrement={() =>
                    dispatch(update(orderRow.articleNumber, quantity - 1))
                  }
                />
              );
            })}
          </div>
          <div className="mini-cart-wrap__fixed">
            <div className="cart__summary">
              <div className="cart__summary__info-row">
                <div className="cart__split-row">
                  <span className="cart__split-row-totalText">
                    {includeVAT
                      ? translate('minicart.taxesincluded')
                      : translate('minicart.total')}
                  </span>
                  <span className="cart__split-row__total">{orderTotal}</span>
                </div>
              </div>
              {freeShippingAmount && (
                <div className="cart__summary__free-shipping">
                  <div className="">Kvar till fri frakt</div>
                  <div className="">{freeShippingAmount}</div>
                </div>
              )}
            </div>
            <a href={checkoutUrl} className="cart__checkout-button">
              {translate('minicart.checkout')}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MiniCart;
